import { param } from '../typesafe-routes';

export function oldJsonParam<T>() {
  return param<T>({
    serialize: (value) => {
      if (value == null) return '';
      const params = new URLSearchParams();
      Object.entries(value as Record<string, any>).forEach(([key, val]) => {
        if (val != null) params.set(key, String(val));
      });
      return params.toString();
    },
    parse: (value) => {
      if (value == null || value === '') return undefined as T;
      const params = new URLSearchParams(value);
      const result: Record<string, any> = {};
      params.forEach((val, key) => {
        result[key] = val;
      });
      return result as T;
    },
  });
}
